// @ts-nocheck
// -----------------------------
// Step para productos recomendados (complementos que se añaden al carrito)
const RECOMENDAMOS_STEP_CONFIG = {
  SHOP_DOMAIN: 'gf7q0f-ma.myshopify.com',
  TAG: 'complemento-cart',
  PRODUCTS_LIMIT: 250,
  PREFERRED_ORDER: ['recommended', 'popular', 'featured'],
  MULTI_SELECT: true,
  USE_BASIC_FALLBACK: true,
  MOSTRAR_IMAGENES_PRODUCTO: true
};

class RecomendamosStep extends LensConfiguratorStep {
  constructor(configurator, options = {}) {
    // Para mantener compatibilidad con la estructura del configurador
    // usamos el stepKey 'material' (el DOM y la configuración esperan 'material')
    super(configurator, {
      ...options,
      stepKey: 'material',
      title: 'Recomendados',
      description: 'Complementos recomendados para este producto'
    });
  }

  static get STEP_CONFIG() {
    return RECOMENDAMOS_STEP_CONFIG;
  }

  getShopifySearchUrl(query) {
    const shopDomain = this.getShopifyDomain();
    return `https://${shopDomain}/products.json?limit=${RecomendamosStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
  }

  getCurrentLocale() {
    if (this.configurator && this.configurator.locale) return this.configurator.locale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    const htmlLang = document.documentElement && document.documentElement.lang;
    if (htmlLang) return htmlLang.split('-')[0];
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale && ogLocale.content) return ogLocale.content;
    return null;
  }

  buildShopifyProductsUrl(query) {
    const shopDomain = this.getShopifyDomain();
    const locale = this.getCurrentLocale();
    let url = `https://${shopDomain}/products.json?limit=${RecomendamosStep.STEP_CONFIG.PRODUCTS_LIMIT}`;
    if (query && typeof query === 'string') {
      const q = query.replace(/^\?/, '');
      if (q) url += `&${q}`;
    }
    if (locale) url += `&locale=${encodeURIComponent(locale)}`;
    return url;
  }

  getShopifyDomain() {
    if (this.configurator && this.configurator.shopDomain) return this.configurator.shopDomain;
    if (window.__AINY_SHOP_DOMAIN) return window.__AINY_SHOP_DOMAIN;
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    const shopifyMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopifyMeta && shopifyMeta.content) {
      const match = shopifyMeta.content.match(/([^.]+\.myshopify\.com)/);
      if (match) return match[1];
    }
    return RecomendamosStep.STEP_CONFIG.SHOP_DOMAIN || 'gf7q0f-ma.myshopify.com';
  }

  async init() {
    if (typeof this.loadConfiguration === 'function') {
      await this.loadConfiguration();
    }
  }

  async loadConfiguration() {
    if (!this.configurator.config) this.configurator.config = {};
      // Guardar en 'materials' para mantener compatibilidad con el resto del sistema
      this.configurator.config.materials = await this.loadRecommendedFromShopify();
    try { this.render(); } catch (e) { console.warn('⚠️ Error al re-renderizar RecomendamosStep:', e); }
  }

  async loadRecommendedFromShopify() {
    try {
      let products = [];
      if (window.LensStepUtils && typeof window.LensStepUtils.fetchProductsByTag === 'function') {
        products = await window.LensStepUtils.fetchProductsByTag(this.configurator, RecomendamosStep.STEP_CONFIG.TAG, RecomendamosStep.STEP_CONFIG.PRODUCTS_LIMIT);
      } else {
        const productsUrl = this.buildShopifyProductsUrl(`?q=tag:${RecomendamosStep.STEP_CONFIG.TAG}`);
        const res = await fetch(productsUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        const d = await res.json();
        products = (d.products || []).filter(p => p.tags && p.tags.includes(RecomendamosStep.STEP_CONFIG.TAG));
      }

      if (!products || products.length === 0) {
        console.warn('⚠️ No se encontraron productos con tag "complemento-cart" en Shopify');
        return this.getBasicFallback();
      }

      const items = {};
      products.forEach(product => {
        const key = product.handle ? String(product.handle).toLowerCase().trim() : `prod-${product.id}`;
        const price = (window.LensStepUtils && typeof window.LensStepUtils.parsePrice === 'function')
          ? window.LensStepUtils.parsePrice(product)
          : (product.variants && product.variants[0] && product.variants[0].price) ? parseFloat(product.variants[0].price) : 0;

        // Normalizar array de imágenes a URLs simples para el carousel
        const images = (product.images && product.images.length)
          ? product.images.map(img => (typeof img === 'string' ? img : (img && (img.src || img.src_url || img.url) ? (img.src || img.src_url || img.url) : null))).filter(Boolean)
          : [];

        items[key] = {
          name: product.title,
          description: product.body_html ? product.body_html : '',
          price: price,
          productId: product.id,
          handle: product.handle,
          image: images.length > 0 ? images[0] : null,
          images: images, // array de URLs para carousel
          variants: product.variants
        };
      });

      if (Object.keys(items).length === 0) {
        if (RecomendamosStep.STEP_CONFIG.USE_BASIC_FALLBACK) return this.getBasicFallback();
        return {};
      }

      return items;
    } catch (error) {
      console.warn('❌ Error cargando recomendados:', error);
      return this.getBasicFallback();
    }
  }

  getBasicFallback() {
    return {
      example_addon: { name: 'Complemento Ejemplo', price: 15, description: 'Complemento temporal', isDefault: true }
    };
  }

  render() {
    // Mantener compatibilidad: renderizar en el contenedor material-options
    const container = document.getElementById('material-options');
    if (!container) return;
    const items = this.configurator.config.materials || this.getBasicFallback();
    container.innerHTML = '';
    // Asegurarnos de tener un array para las selecciones
    if (!this.configurator.configuration) this.configurator.configuration = {};
    if (!Array.isArray(this.configurator.configuration.recomendado)) {
      this.configurator.configuration.recomendado = [];
    }

    Object.entries(items).forEach(([key, item]) => {
      // Crear un elemento simple para recomendados (no dentro de .option-card)
      const el = document.createElement('div');
      el.className = 'recomendado-item';
      el.dataset.key = key;
      el.dataset.type = 'recomendado';

      // Media: soportar imágenes múltiples como carousel o una sola imagen
      const displayName = item.name || key;
      const images = Array.isArray(item.images) && item.images.length > 0 ? item.images : (item.image ? [item.image] : []);
      if (images.length === 1) {
        const imgWrap = document.createElement('div');
        imgWrap.className = 'recomendado-media';
        const img = document.createElement('img');
        img.src = images[0];
        img.alt = displayName;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
        el.appendChild(imgWrap);
      } else if (images.length > 1) {
        // Carousel markup (simple, sin dependencias)
        const imgWrap = document.createElement('div');
        imgWrap.className = 'recomendado-media carousel';
        imgWrap.setAttribute('data-current', '0');

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'carousel-prev header-nav-btn';
        prevBtn.setAttribute('aria-label', 'Anterior');
        prevBtn.textContent = '‹';

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'carousel-next header-nav-btn';
        nextBtn.setAttribute('aria-label', 'Siguiente');
        nextBtn.textContent = '›';

        const track = document.createElement('div');
        track.className = 'carousel-track';

        images.forEach((src, i) => {
          const slide = document.createElement('div');
          slide.className = 'carousel-slide';
          slide.dataset.index = String(i);
          const img = document.createElement('img');
          img.src = src;
          img.alt = `${displayName} (${i + 1})`;
          img.loading = 'lazy';
          slide.appendChild(img);
          track.appendChild(slide);
        });

        imgWrap.appendChild(prevBtn);
        imgWrap.appendChild(track);
        imgWrap.appendChild(nextBtn);

        // Indicators (dots)
        const indicators = document.createElement('div');
        indicators.className = 'carousel-indicators';
        images.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel-indicator';
          dot.dataset.index = String(i);
          dot.setAttribute('aria-label', `Ir a ${i + 1}`);
          indicators.appendChild(dot);
        });
        imgWrap.appendChild(indicators);

        el.appendChild(imgWrap);

        // Lógica de navegación
        try {
          let current = 0;
          const slidesCount = track.children.length;
          const dots = imgWrap.querySelectorAll('.carousel-indicator');
          const setActiveDot = (idx) => {
            dots.forEach((d) => d.classList.toggle('active', Number(d.dataset.index) === idx));
          };

          const update = (idx) => {
            current = idx < 0 ? slidesCount - 1 : (idx >= slidesCount ? 0 : idx);
            const offset = -current * 100;
            track.style.transform = `translateX(${offset}%)`;
            imgWrap.setAttribute('data-current', String(current));
            setActiveDot(current);
          };

          prevBtn.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current - 1); });
          nextBtn.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current + 1); });
          track.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); update(current + 1); });

          // Dot click handlers
          dots.forEach((dot) => {
            dot.addEventListener('click', (ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              const idx = Number(dot.dataset.index);
              update(idx);
            });
          });

          // Touch / swipe support
          let startX = 0;
          let deltaX = 0;
          let isTouching = false;

          const onTouchStart = (ev) => {
            isTouching = true;
            startX = ev.touches ? ev.touches[0].clientX : ev.clientX;
            deltaX = 0;
            track.style.transition = 'none';
          };

          const onTouchMove = (ev) => {
            if (!isTouching) return;
            const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
            deltaX = x - startX;
            const percent = (deltaX / imgWrap.clientWidth) * 100;
            const offset = -current * 100 + percent;
            track.style.transform = `translateX(${offset}%)`;
          };

          const onTouchEnd = () => {
            if (!isTouching) return;
            isTouching = false;
            track.style.transition = '';
            if (Math.abs(deltaX) > imgWrap.clientWidth * 0.2) {
              if (deltaX < 0) update(current + 1); else update(current - 1);
            } else {
              update(current);
            }
          };

          imgWrap.addEventListener('touchstart', onTouchStart, { passive: true });
          imgWrap.addEventListener('touchmove', onTouchMove, { passive: true });
          imgWrap.addEventListener('touchend', onTouchEnd);
          imgWrap.addEventListener('mousedown', (ev) => onTouchStart(ev));
          window.addEventListener('mousemove', (ev) => onTouchMove(ev));
          window.addEventListener('mouseup', () => onTouchEnd());

          // Inicializar estado
          update(0);
        } catch (e) {
          // no-op
        }
      }

      // Texto: nombre, descripción y precio
      const meta = document.createElement('div');
      meta.className = 'recomendado-meta';
      const title = document.createElement('h4');
      title.textContent = item.name || key;
      meta.appendChild(title);
      if (item.description) {
        const desc = document.createElement('p');
        desc.className = 'recomendado-desc';
        desc.innerHTML = item.description;
        meta.appendChild(desc);
      }
      if (item.price !== undefined && item.price !== null) {
        const price = document.createElement('div');
        price.className = 'recomendado-price';
        price.textContent = item.price > 0 ? `+${this.configurator.formatPrice(item.price)}` : '';
        meta.appendChild(price);
      }
      el.appendChild(meta);

      // Controles: botón añadir / quitar
      const controls = document.createElement('div');
      controls.className = 'recomendado-controls';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'recomendado-toggle';

      const isSelected = Array.isArray(this.configurator.configuration.recomendado) && this.configurator.configuration.recomendado.includes(key);
      const addIcon = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M11 11V5a1 1 0 1 1 2 0v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6z"/></svg>';
      const removeIcon = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M19 13H5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z"/></svg>';

      const setBtnState = (selected) => {
        if (selected) {
          btn.innerHTML = `${removeIcon}<span class="recomendado-label">Quitar</span>`;
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.innerHTML = `${addIcon}<span class="recomendado-label">Añadir</span>`;
          btn.setAttribute('aria-pressed', 'false');
        }
      };

      setBtnState(!!isSelected);

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const sel = this.configurator.configuration.recomendado || [];
        const idx = sel.indexOf(key);
        if (idx === -1) {
          sel.push(key);
          setBtnState(true);
        } else {
          sel.splice(idx, 1);
          setBtnState(false);
        }
        this.configurator.configuration.recomendado = sel;

        try { this.configurator.calculatePrice(); } catch (e) {}
        try { this.configurator.updatePriceDisplay(); } catch (e) {}
        try { this.configurator.updateDrawerFooter(); } catch (e) {}
      });

      controls.appendChild(btn);
      el.appendChild(controls);

      container.appendChild(el);
    });
  }

  // Pequeños helpers
  parsePrice(product) { if (!product.variants || product.variants.length === 0) return 0; return parseFloat(product.variants[0].price || 0); }
}

window.RecomendamosStep = RecomendamosStep;

// Los estilos para los controles de Recomendados han sido movidos a assets/lens-drawer.css
